import { useEffect, useState } from "react";
import { FileArchive, Loader2, Newspaper } from "lucide-react";
import { api } from "@/lib/api";

// Who has been reading the press kit, and in which language they took it.
export const PressStats = () => {
  const [stats, setStats] = useState(null);
  const [days, setDays] = useState(30);

  useEffect(() => {
    setStats(null);
    api.get("/press/stats", { params: { days } })
      .then(({ data }) => setStats(data))
      .catch((e) => console.error("could not load the press stats", e));
  }, [days]);

  const top = Math.max(1, ...(stats?.languages || []).map((l) => l.pages + l.zips));

  return (
    <div className="rounded-3xl border border-white/10 bg-panel p-6" data-testid="press-stats">
      <div className="flex flex-wrap items-center gap-3">
        <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-ink-soft">
          <Newspaper className="h-4 w-4 text-brand" /> The press kit
        </p>
        <div className="ms-auto flex gap-1">
          {[7, 30, 90].map((d) => (
            <button
              key={d}
              data-testid={`press-stats-days-${d}`}
              onClick={() => setDays(d)}
              className={`min-h-[28px] rounded-full border px-3 text-[11px] transition-colors ${
                days === d ? "border-brand bg-brand/15 text-brand"
                  : "border-white/15 text-ink-soft hover:text-ink"}`}
            >
              {d}d
            </button>
          ))}
        </div>
      </div>

      {!stats ? (
        <Loader2 className="mt-4 h-4 w-4 animate-spin text-ink-soft" />
      ) : stats.pages + stats.zips === 0 ? (
        <p className="mt-3 text-sm text-ink-soft" data-testid="press-stats-empty">
          Nobody has opened the kit in the last {days} days.
        </p>
      ) : (
        <>
          <div className="mt-4 flex flex-wrap gap-6">
            <p className="text-sm" data-testid="press-stats-pages">
              <span className="block font-display text-3xl font-bold text-brand">{stats.pages}</span>
              <span className="text-ink-soft">opened the kit</span>
            </p>
            <p className="text-sm" data-testid="press-stats-zips">
              <span className="block font-display text-3xl font-bold">{stats.zips}</span>
              <span className="text-ink-soft">took the whole zip</span>
            </p>
          </div>

          <ul className="mt-5 space-y-1.5" data-testid="press-stats-languages">
            {stats.languages.map((row) => (
              <li key={row.lang} className="flex items-center gap-2 text-[11px]"
                  data-testid={`press-stats-lang-${row.lang}`}>
                <span className="w-10 shrink-0 uppercase text-ink">{row.lang}</span>
                <span className="h-1.5 min-w-[3px] rounded-full bg-brand/70"
                      style={{ width: `${Math.max(4, ((row.pages + row.zips) / top) * 100)}%` }} />
                <span className="shrink-0 tabular-nums text-ink-soft">
                  {row.pages} {row.pages === 1 ? "visit" : "visits"}
                  {row.zips ? (
                    <span className="ms-1.5 inline-flex items-center gap-1 text-brand">
                      <FileArchive className="h-3 w-3" />{row.zips}
                    </span>
                  ) : null}
                </span>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};
